import { render, staticRenderFns } from "./PrintableHerbalMedicineOrder.vue?vue&type=template&id=58e6fe24&scoped=true&"
import script from "./PrintableHerbalMedicineOrder.vue?vue&type=script&lang=js&"
export * from "./PrintableHerbalMedicineOrder.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/print.css?vue&type=style&index=0&id=58e6fe24&scoped=true&lang=css&"
import style1 from "./PrintableHerbalMedicineOrder.vue?vue&type=style&index=1&id=58e6fe24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6fe24",
  null
  
)

export default component.exports